import type { ReactNode } from 'react';
import { useMediaQuery } from '@mantine/hooks';

export interface FieldLayoutOptions {
  label?: ReactNode;
  hideLabel?: boolean;
}

export const useFieldLayout = ({ label, hideLabel }: FieldLayoutOptions) => {
  const isMobile = useMediaQuery('(max-width: 48em)', undefined, {
    getInitialValueInEffect: false
  });

  return {
    label: isMobile || !hideLabel ? label : undefined,
    ariaLabel: typeof label === 'string' ? label : undefined,
    inputHeight: isMobile ? 44 : 36,
    inputBackground: 'var(--color-bg-surface)'
  };
};
